import React, { useEffect } from 'react';
import { useState } from 'react';
import { IcoAdd, IcoMinus } from '..';
import './accordion.css';

export interface IData {
  id: string;
  title: string;
  content: JSX.Element | JSX.Element[];
}

export interface IAccordionProps {
  data: Array<IData>;
  tabSelect: string;
  actionTab: (id: string) => void;
  type?: string;
  cy: string;
  leftHeaderContent?: JSX.Element;
  disabledHeaderClick?: boolean;
  openAccordion?: string;
}

export const Accordion: React.FC<IAccordionProps> = ({
  data,
  tabSelect = '',
  actionTab = () => null,
  type,
  cy,
  leftHeaderContent = null,
  disabledHeaderClick = false,
  openAccordion = '',
}) => {
  const [tabStateId, setTabStateId] = useState<string>(openAccordion);
  useEffect(() => {
    if (data) {
      const selectTab = data.filter(
        (e: IData) => e.id === (tabSelect ? tabSelect : data[0].id)
      );
      if (selectTab.length) {
        setTabStateId(selectTab[0].id);
      }
    }
  }, [data, tabSelect]);

  useEffect(() => {
    if (openAccordion) {
      setTabStateId(openAccordion);
    }
  }, [openAccordion]);

  const onHeaderClick = (item: IData) => {
    if (!disabledHeaderClick) {
      setTabStateId(tabStateId === item.id ? '' : item.id);
      actionTab(item.id);
    }
  };

  return (
    <div
      className={`${type === 'custom' ? 'custom-tab' : 'box-tab'} `}
      data-cy={`Accordion${cy}FullContainer`}
    >
      {data?.map((item) => (
        <div
          key={`accordion-${item.id}`}
          className={item.id === tabStateId ? 'open' : ''}
          data-cy={`Accordion${cy}[${item.id}]Container`}
        >
          <div
            className="accordion-header"
            onClick={() => onHeaderClick(item)}
            data-cy={`Accordion${cy}${item.id}ClickOpenClose`}
          >
            {leftHeaderContent || null}
            <h6 data-cy={`Accordion${cy}${item.id}Title`}>{item.title}</h6>
            <span data-cy={`Accordion${cy}${item.id}TitleIcon`}>
              {item.id === tabStateId ? (
                <IcoMinus cy={`Accordion${cy}${item.id}`} />
              ) : (
                <IcoAdd cy={`Accordion${cy}${item.id}`} />
              )}
            </span>
          </div>
          <div
            className="accordion-container"
            data-cy={`Accordion${cy}${item.id}ContentContainer`}
          >
            {item.content}
          </div>
        </div>
      ))}
    </div>
  );
};
